import script from "./FranchiseSyncComparePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./FranchiseSyncComparePanel.vue?vue&type=script&setup=true&lang=js"

import "./FranchiseSyncComparePanel.vue?vue&type=style&index=0&id=8f68b6ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f68b6ae"]])

export default __exports__